export const captchaTokenCookieName = 'cy-test-captcha-token';
